import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { dashboardApi } from '@/store/api/base/api.base';
import uiReducer from './ui/ui.slice';
import authReducer from './auth/auth.slice';

const rootReducer = combineReducers({
    ui: persistReducer({ key: 'bedashboard:ui', storage, version: 1 }, uiReducer),
    auth: authReducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
});

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefault) => getDefault({
        serializableCheck: { ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER] },
    }).concat(dashboardApi.middleware),
});

setupListeners(store.dispatch);

export const persistor = persistStore(store);

export type TypeRootState = ReturnType<typeof rootReducer>;
export type TypeAppDispatch = typeof store.dispatch;
